import styles from "styles/Quantity.module.scss";
import GetIcon from "components/GetIcon";
import { BasketContext } from "context/BasketContext";
import { useContext, useRef, useEffect } from "react";

const Quantity = ({ data, isInCart = false, min = 1, max = 10 }) => {
    const inp = useRef(null);
    const { basketItems, setBasketItems, setCurrentQuantity } = useContext(BasketContext);

    useEffect(() => {
        const initialQuantity = isInCart
            ? basketItems.find((item) => item.id === data.id)?.quantity
            : min;
        inp.current.value = initialQuantity;
        if (!isInCart) {
            setCurrentQuantity(initialQuantity);
        }
    }, [data, basketItems, isInCart, setCurrentQuantity, min]);

    const updateQuantity = (newQuantity) => {
        if (newQuantity >= min && newQuantity <= max) {
            if (isInCart) {
                const updatedBasketItems = basketItems.map((item) =>
                    item.id === data.id ? { ...item, quantity: newQuantity } : item
                );
                setBasketItems(updatedBasketItems);
            } else {
                setCurrentQuantity(newQuantity);
            }
        }
    };

    const increase = () => {
        const newQuantity = parseInt(inp.current.value, 10) + 1;
        if (newQuantity <= max) {
            inp.current.value = newQuantity;
            updateQuantity(newQuantity);
        }
    };

    const decrease = () => {
        const newQuantity = parseInt(inp.current.value, 10) - 1;
        if (newQuantity >= min) {
            inp.current.value = newQuantity;
            updateQuantity(newQuantity);
        }
    };

    return (
        <div className={styles.quantity}>
            <button type="button" className={styles.quantityBtn} onClick={decrease}>
                <GetIcon icon="BsDash" size={20} />
            </button>
            <input
                type="number"
                min={min}
                max={max}
                ref={inp}
                onChange={(e) => {
                    const newQuantity = parseInt(e.target.value, 10);
                    updateQuantity(newQuantity);
                }}
            />
            <button type="button" className={styles.quantityBtn} onClick={increase}>
                <GetIcon icon="BsPlus" size={20} />
            </button>
        </div>
    );
};

export default Quantity;
